export function firstWordToLowerCase(str) {
  if (!str || str.length === 1) {
    return str.toLowerCase();
  }
  return "".concat(str.substring(0, 1).toLowerCase()).concat(str.substring(1, str.length));
}